import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { VehicleDiagnosticsService } from '../../service/vehicle-diagnostics.service';
import { Injectable } from '@angular/core';
import {
  loadDtcList,
  vehicleDiagnosticsFailure,
  loadMilStatus,
  loadMilStatusSuccess,
  loadDtcListSuccess,
  loadTooltipDtcSuccess,
  loadTooltipDtc,
  loadTooltipMilStatus,
  loadTooltipMilStatusSuccess,
  loadActiveLampDtcSuccess,
  loadActiveLampDtc,
} from '../actions';

@Injectable()
export class VehicleDiagnosticsEffects {
  constructor(
    private actions$: Actions,
    private engineLightService: VehicleDiagnosticsService,
  ) {}

  loadChartDtc = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDtcList),
      switchMap(({ vehicleId, dateRange }) => {
        return this.engineLightService.getDtc(vehicleId, dateRange).pipe(
          map((shortDtc) => loadDtcListSuccess({ shortDtc })),
          catchError((error) => of(vehicleDiagnosticsFailure({ error }))),
        );
      }),
    ),
  );

  getActiveLampDtc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadActiveLampDtc),
      switchMap(({ vehicleId }) => {
        return this.engineLightService.getDtc(vehicleId).pipe(
          map((activeLampDtc) => loadActiveLampDtcSuccess({ activeLampDtc })),
          catchError((error) => of(vehicleDiagnosticsFailure({ error }))),
        );
      }),
    ),
  );

  loadMilStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMilStatus),
      switchMap(({ vehicleId }) => {
        return this.engineLightService.getMilStatus(vehicleId).pipe(
          map((milStatus) => loadMilStatusSuccess({ milStatus })),
          catchError((error) => of(vehicleDiagnosticsFailure({ error }))),
        );
      }),
    ),
  );

  loadTooltipMilStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTooltipMilStatus),
      switchMap(({ vehicleId }) => {
        return this.engineLightService.getMilStatus(vehicleId).pipe(
          map((tooltipMilStatus) =>
            loadTooltipMilStatusSuccess({ tooltipMilStatus }),
          ),
          catchError((error) => of(vehicleDiagnosticsFailure({ error }))),
        );
      }),
    ),
  );

  loadTooltipDtc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTooltipDtc),
      switchMap(({ vehicleId }) => {
        return this.engineLightService.getDtc(vehicleId).pipe(
          map((tooltipDtc) => loadTooltipDtcSuccess({ tooltipDtc })),
          catchError((error) => of(vehicleDiagnosticsFailure({ error }))),
        );
      }),
    ),
  );
}
